import { SOCIALS } from "@/lib/social";

/* Homepage content shared by the round-5 page and the concept pages. Most of
   it is placeholder until Chelsea confirms the real quotes, picks, and partners. */

/* Shown when the videos API isn’t reachable (e.g. local dev without the backend). */
export const FALLBACK_VIDEOS = [
  { id: "f1", title: "I made a matching cereal-box print outfit", tag: "New make", img: "/chelsea.JPG", pos: "50% 30%", url: SOCIALS.youtube.url },
  { id: "f2", title: "Quilt show haul: everything I couldn’t leave without", tag: "Haul", img: "/img/products/qs-mat.jpg", pos: "50% 40%", url: SOCIALS.youtube.url },
  { id: "f3", title: "Behind the scenes: filming, sewing, creating", tag: "Vlog", img: "/chelsea-rainbow-portrait.jpg", pos: "50% 25%", url: SOCIALS.instagram.url },
];

export const CHAT = [
  { who: "Sam", text: "wait how did you get that corner so crisp??" },
  { who: "Jo", text: "COSMO CAMEO 🐈" },
  { who: "Lee", text: "first zipper I haven’t cried over" },
  { who: "Mara", text: "watching the replay at 2am, no regrets" },
];

/* Placeholder quotes carried over from the current homepage; swap for real ones. */
export const WORDS = [
  { quote: "Chelsea’s energy is absolutely contagious. She makes sewing feel accessible and FUN.", name: "Sarah M.", tag: "Fellow sewist" },
  { quote: "I started sewing because of her TikToks. Now I have a whole closet of handmade clothes!", name: "Jamie L.", tag: "Community member" },
  { quote: "The best creator content out there. Real, relatable, and always makes my day better.", name: "Priya K.", tag: "YouTube subscriber" },
];

/* Placeholder picks; real ones come from the favorites admin. */
export const FAVES = [
  { name: "Quilters Select cutting mat", why: "The mat under every project", img: "/img/products/qs-mat.jpg", tag: "Tool" },
  { name: "Husqvarna Viking Topaz 65", why: "My embroidery workhorse", img: "/img/products/husqvarna-viking-topaz-65.jpg", tag: "Machine" },
  { name: "Loose Threads merch", why: "For fellow fabric hoarders", img: "/img/chelsea.jpeg", tag: "Merch" },
];

/* Placeholder: Stitches Night Out sponsor logos. Replace with Chelsea’s confirmed partners. */
export const BRANDS = [
  { name: "Baby Lock", src: "/events/sponsors/baby-lock.svg" },
  { name: "Quilt 101", src: "/events/sponsors/quilt-101.png" },
  { name: "Oliso", src: "/events/sponsors/oliso.png" },
  { name: "Cutterpillar", src: "/events/sponsors/cutterpillar.png" },
  { name: "Harmony", src: "/events/sponsors/harmony.png" },
];
